import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UniversalSearchService } from '../../../../universal-search/services/universal-search.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CustomFiltersService } from '../../../../services/custom-filters.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { CaseManagementService } from '../../../../case-management/case-management.service';
import { Subject } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.scss'],
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
})
export class UserFilterComponent implements OnInit, OnDestroy {
  private ss = inject(SessionStorageService);
  usServ = inject(UniversalSearchService);
  private cms = inject(CaseManagementService);
  cstmFltrSrvc = inject(CustomFiltersService);

  @Input() field;
  @Input() filterForm;
  @Input() groupKey;
  @Input() gridName: string;
  @Output() selectionChange = new EventEmitter();
  @Output() clearFilter = new EventEmitter();
  userControl = new FormControl<any>('');
  unsubscribe = new Subject();
  dropdownLoading: boolean;
  globals = this.ss.get('globals');
  dropdownNoResults: boolean;
  previousSelectedVal = '';

  ngOnInit(): void {
    this.userControl =
      this.filterForm.controls[this.groupKey].controls[this.field.varName];
    this.userControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(value => {
        if (value && value.length >= 1) {
          this.dropdownLoading = true;
          this.getUserList(value);
        }
      });

    this.cstmFltrSrvc.updateDropdowns$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: field => {
          if (field) {
            if (
              field['values']?.['field'] === this.field.varName &&
              (typeof field['values']?.['value'] === 'number' ||
                field['values']?.['value'])
            ) {
              this.userControl.setValue(field['values']?.['value']);
              this.previousSelectedVal = field['values']?.['value'];
            } else if (this.field.varName === field['varName']) {
              this.userControl.setValue(field['values']?.['value']);
              this.previousSelectedVal = field['values']?.['value'];
            }

            if (
              this.field.conditionalField &&
              field['varName'] === this.field.conditionalField &&
              field?.['values']?.['value'] &&
              (field['values']['value'] === this.field.conditionalValue ||
                field['values']['value'].includes(this.field.conditionalValue))
            ) {
              this.userControl.enable();
            }
          }
        },
        error: error => alert(error),
      });

    if (this.field.conditionalField) {
      this.cstmFltrSrvc.updateConditionalFilter$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: passedFilter => {
            if (
              passedFilter['varName'] === this.field.conditionalField &&
              (passedFilter['values'] === this.field.conditionalValue ||
                passedFilter['values'].includes(this.field.conditionalValue))
            ) {
              this.userControl.enable();
            } else if (
              passedFilter['varName'] === this.field.conditionalField &&
              (passedFilter['values'] !== this.field.conditionalValue ||
                !passedFilter['values'].includes(this.field.conditionalValue))
            ) {
              this.userControl.disable();
            }
          },
          error: error => console.error('Error: ', error),
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  onBlur(ev) {
    if (ev.target.value === '') {
      this.userControl.setValue(this.previousSelectedVal);
    }
  }

  changeSelection(ev) {
    this.previousSelectedVal = ev.option.value;
    this.selectionChange.emit(ev);
  }

  resetFilter(ev) {
    if (this.userControl['value']) {
      this.previousSelectedVal = '';
      this.userControl.setValue('');
    }
    this.clearFilter.emit(ev);
  }

  getUserList(searchString?: string) {
    // Possible temporary thing for CaseManagement.
    // Strange behavior for these two fields without the following code.
    if (
      this.field.varName === 'AssignedTo' ||
      this.field.varName === 'SubmittedBy'
    ) {
      this.cms.getCmUserFilterList(searchString).subscribe(resp => {
        this.dropdownNoResults = true;
        const newUsersList = resp.Users.map(rep => ({
          value: rep.UserID,
          display: rep.UserName,
        }));
        this.field.fullField.externalFilter['options'] = newUsersList;
        if (this.field.fullField.externalFilter['options'].length > 0) {
          this.dropdownNoResults = false;
        }
        this.dropdownLoading = false;
        this.cms.setModalPreparing(false);
      });
    } else {
      this.usServ.userSearch(searchString).subscribe(resp => {
        this.dropdownNoResults = true;
        const newUsersList = resp.names.map(rep => ({
          value: rep.id,
          display: rep.name,
        }));
        this.field.fullField.externalFilter['options'] = newUsersList;
        if (this.field.fullField.externalFilter['options'].length > 0) {
          this.dropdownNoResults = false;
        }
        this.dropdownLoading = false;
      });
    }
  }

  getDropdownOptions() {
    return this.field.fullField.externalFilter['options'] || [];
  }

  showClearButton(fieldName) {
    if (this.filterForm.controls[this.groupKey].controls[fieldName].value) {
      return true;
    }
    return false;
  }
}
